import React from "react";

function Page2() {
  return (
    <div id="page2" className="page">
      <div className="description">
        <div className="inner">
          <div className="texts">
            <div className="background" />
            <h2 className="outline outline--small">Advanced<br/>AI/ML</h2>
            <p>capabilities deliver real-time<br/>situational awareness.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Page2;
